/* user modules */
angular.module('bmsApp.user', ['ui.router'])
	.config(['$stateProvider', '$urlRouterProvider', function config($stateProvider, $urlRouterProvider) {
		$stateProvider

			.state('empty', {
				url: '',
				controller: 'EmptyCtrl',
				data: {
					requireLogin: true
				},
				ncyBreadcrumb: {
					label: 'Redirecting...'
				}
			})

			.state('root', {
				url: '/',
				controller: 'EmptyCtrl',
				data: {
					requireLogin: true
				},
				ncyBreadcrumb: {
					label: 'Redirecting...'
				}
			})

			.state('login', {
				url: '/login?redirect',
				templateUrl: 'ng/user/login.html',
				controller: 'LoginCtrl',
				data: {
					requireLogin: false
				},
				params: {
					redirect: null
				},
				ncyBreadcrumb: {
					label: 'Login'
				}
			})

			.state('logout', {
				url: '/out?redirect',
				templateUrl: 'ng/user/logout.html',
				controller: 'LogoutCtrl',
				data: {
					requireLogin: false
				},
				params: {
					redirect: null
				},
				ncyBreadcrumb: {
					label: 'Logout'
				}
			})

			.state('activate', {
				url: '/activate/{key}',
				templateUrl: 'ng/user/activate.html',
				controller: 'ActivateCtrl',
				data: {
					requireLogin: false
				},
				ncyBreadcrumb: {
					label: 'Activate System'
				}
			})

			.state('activateUser', {
				url: '/activate/{key}/{type}',
				templateUrl: 'ng/user/activate.html',
				controller: 'ActivateCtrl',
				data: {
					requireLogin: false
				},
				ncyBreadcrumb: {
					label: 'Activate Account'
				}
			})

			.state('instanceSelection', {
				url: '/instance-selection',
				templateUrl: 'ng/user/instance-selection.html',
				controller: 'InstanceSelectionCtrl',
				data: {
					requireLogin: true
				},
				ncyBreadcrumb: {
					label: 'Instance Selection'
				}
			})

			.state('maintenanceMode', {
				url: '/maintenance-mode',
				templateUrl: 'ng/user/maintenance.html',
				data: {
					requireLogin: true
				},
				ncyBreadcrumb: {
					label: 'Down for maintenance'
				}
			})


	}])
	.run(function () {

	})
	
	.constant('AUTH_EVENTS', {
		loginSuccess: 'auth-login-success',
		loginFailed: 'auth-login-failed',
		logoutSuccess: 'auth-logout-success',
		sessionTimeout: 'auth-session-timeout',
		notAuthenticated: 'auth-not-authenticated',
		notAuthorized: 'auth-not-authorized'
	})
	
	.constant('BMSPermission', {
		CRM: 'crm',
		EMPLOYEES: 'employees',
		MARKETING: 'marketing',
		WORK_PORTAL: 'work_portal',
		SETTINGS: 'settings',
		ACCOUNTING: 'accounting',
		REPORTING: 'reporting'
	})

;
